export enum FORM_NAMES {
  birthDate = "birthDate",
  name = "name",
}

export type FormTypes = {
  [FORM_NAMES.birthDate]: Date | null;
  [FORM_NAMES.name]: string | null;
};
